import styles from "./pro_feature_check.module.scss"
import parse from "html-react-parser"
import iconSuccessGrayCheck from "images/icons/icon-success-check-gray.svg?raw"

interface Props {
  billingUrl: string
  expirationDate: string
  maxFreeApplets: string
  moveNextView: () => void
  tierName: string
}

const ProFeatureCheck = ({ billingUrl, expirationDate, maxFreeApplets, moveNextView, tierName }: Props) => {
  const proFeatures = [
    "Use multiple actions to do more per Applet",
    "Get faster and more reliable Applet runs",
    "Access exclusive services like Webhooks, RSS Feeds, and more",
    "Create and manage up to 20 Applets",
  ]

  const proPlusFeatures = [
    "Use multiple actions to do more per Applet",
    "Get faster and more reliable Applet runs",
    "Access exclusive services like Webhooks, RSS Feeds, and more",
    "Create and manage unlimited Applets",
    "Use filter code, queries, and AI services",
  ]

  const features = tierName === "Pro+" ? proPlusFeatures : proFeatures

  return (
    <div className={styles.pro_feature_check}>
      <h1 className="mb2--phone mb2--small-phone">Are you sure?</h1>

      <p className={styles.description}>
        On {expirationDate} you will be moved to our free plan, which is limited to {maxFreeApplets} Applets only. If
        you continue with cancellation, you will lose access to all subscription benefits and any future subscriptions
        will be at our latest pricing.
      </p>

      <div className={styles.feature_card}>
        <p className={styles.feature_card_title}>You will lose access to these {tierName} features:</p>
        <ul className={styles.feature_list}>
          {features.map(feature => (
            <li key={feature}>
              {parse(iconSuccessGrayCheck)}
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <div className="cancellation-actions">
          <a className={`button-primary ${styles.keep_plan_button}`} href={billingUrl}>
            Keep my plan
          </a>
        </div>
      </div>

      <a className={styles.continue_link} onClick={moveNextView}>
        Continue to cancel
      </a>
    </div>
  )
}

export default ProFeatureCheck
